import Pusher from 'pusher-js';

const PUSHER_KEY     = process.env.REACT_APP_PUSHER_KEY;
const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER || 'mt1';

let pusherInstance = null;

export const getPusher = () => {
    if (!pusherInstance && PUSHER_KEY) {
        pusherInstance = new Pusher(PUSHER_KEY, { cluster: PUSHER_CLUSTER });
    }
    return pusherInstance;
};
